import { getFooterGradientTriggerConfig } from './orbital-gradient.component.js';

gsap.registerPlugin(ScrollTrigger);

let bgFixedTriggers = [];

window.bgFixedAnimation = function bgFixedAnimation() {
  bgFixedTriggers.forEach((trigger) => trigger.kill());
  bgFixedTriggers = [];

  const bgSectionsElsArr = document.querySelectorAll('[data-parallax-bg-sec]');
  const bgElsArr = document.querySelectorAll('[data-parallax-bg]');
  const bodyBg = document.querySelector('.body-bg');
  const isBodyBgExists = !!bodyBg;
  const activeFixedBackgroundSections = new Set();

  const syncFixedBackgroundState = () => {
    if (!isBodyBgExists) {
      return;
    }

    bodyBg.classList.toggle(
      'is-worked-fixed-bg',
      activeFixedBackgroundSections.size > 0
    );
  };

  bgSectionsElsArr.forEach((bgSecEl, idx) => {
    let startY = 10;
    let endY = 10;
    let startTrigger = 'center';
    let endTrigger = 'center';

    const isFooterSection = bgSecEl?.classList.contains('footer');
    const bgEl = isFooterSection
      ? bodyBg?.querySelector('.footer-bg')
      : bgElsArr[idx];
    const footerTriggerConfig = getFooterGradientTriggerConfig({
      footer: bgSecEl,
      clients: document.querySelector('.clients-gradient-sec'),
      isEnhanced: document.documentElement.classList.contains(
        'is-footer-orbital-gradient-ready'
      ),
    });

    if (bgSecEl?.classList.contains('latest-works-sec-wr')) {
      startY = window.innerWidth > 1024 ? 6 : 10;
      endY = 0;

      endTrigger = '35%';

      if (window.innerWidth <= 640) {
        endY = 0;
      }
    }

    if (bgSecEl?.classList.contains('video-full-sec')) {
      startY = 0;
      endY = 0;
    }

    if (bgSecEl?.classList.contains('evolve-video-bg-wr')) {
      startY = 6;
      endY = window.innerWidth > 640 ? 0 : 3;
      // endTrigger = '35%';

      if (window.innerWidth <= 640) {
        endTrigger = '62%';
        startY = 0;
        endY = 0;
      }
    }

    if (bgSecEl?.classList.contains('for-clients-sec')) {
      startY = window.innerWidth > 640 ? 0 : 10;
      endY = 0;

      startTrigger = '35%';
      /*endTrigger = '35%';*/
      /*endTrigger = '10%';*/
    }

    if (bgSecEl?.classList.contains('footer')) {
      startY = window.innerWidth > 640 ? 15 : 6;
      endY = 0;

      if (document.querySelector('.contact-sec')) {
        startY = 200;
      }
    }

    if (bgSecEl?.classList.contains('for-footer-bg-wr')) {
      endY = 1000;
    }

    if (!bgSecEl || !bgEl) return;

    const trigger = isFooterSection ? footerTriggerConfig.trigger : bgSecEl;
    const start =
      isFooterSection && footerTriggerConfig.start
        ? footerTriggerConfig.start
        : `top-=${startY}% ${startTrigger}`;

    const scrollTrigger = ScrollTrigger.create({
      trigger,
      ...(isFooterSection && footerTriggerConfig.endTrigger
        ? { endTrigger: footerTriggerConfig.endTrigger }
        : {}),
      start,
      end: `bottom+=${endY}% ${endTrigger}`,
      scrub: true,
      invalidateOnRefresh: true,
      // markers: true,
      onToggle: (self) => {
        const isVisible = bgEl.classList.contains('is-visible-bg');

        const isFooter = isFooterSection;
        const isFooterGradientWorked =
          isFooter &&
          bgSecEl.classList.contains('is-worked-gradient-animation');

        const isLatestWorks = bgSecEl.classList.contains('latest-works-sec-wr');
        const isLatestWorksGradientWorked =
          isLatestWorks &&
          bgSecEl.classList.contains('is-worked-gradient-animation');

        const isProject = bgSecEl.classList.contains('project-sec-wr');
        const isProjectGradientWorked =
          isProject &&
          bgSecEl.classList.contains('is-worked-gradient-animation');
        if (!self.isActive) {
          activeFixedBackgroundSections.delete(bgSecEl);
          syncFixedBackgroundState();

          if (isVisible) {
            bgEl.classList.remove('is-visible-bg');
          }

          if (bgSecEl?.classList.contains('video-full-sec')) {
            bodyBg.classList.remove('is-worked-full-video-bg');
          }

          if (isFooter && isFooterGradientWorked) {
            bgSecEl.classList.remove('is-worked-gradient-animation');
            pauseFooterGradientAnimation();
          }

          if (isProject && isProjectGradientWorked) {
            bgSecEl.classList.remove('is-worked-gradient-animation');
            pauseProjectGradientAnimation();
          }

          if (isLatestWorks && isLatestWorksGradientWorked) {
            bgSecEl.classList.remove('is-worked-gradient-animation');
            pauseLatestWorksGradientAnimation();

            const beBoldSecWr = document.querySelector('.be-bold-sec-wr');

            if (
              beBoldSecWr &&
              isElementInViewport(beBoldSecWr) &&
              window.innerWidth >= 1024
            ) {
              bodyBg.classList.remove('is-bg-dark');
              bodyBg.classList.add('is-bg-light');
              document.querySelector('body').classList.remove('is-bg-dark');
              document.querySelector('body').classList.add('is-bg-light');
            }
          }
        } else {
          activeFixedBackgroundSections.add(bgSecEl);
          syncFixedBackgroundState();

          if (!isVisible) {
            bgEl.classList.add('is-visible-bg');
          }
          if (isBodyBgExists) {
            if (bgSecEl?.classList.contains('video-full-sec')) {
              bodyBg.classList.add('is-worked-full-video-bg');
            }

            if (bgSecEl?.classList.contains('latest-works-sec-wr')) {
              bodyBg.classList.remove('is-worked-full-video-bg');
            }
          }

          if (isFooter && !isFooterGradientWorked) {
            bgSecEl.classList.add('is-worked-gradient-animation');
            resumeFooterGradientAnimation();
          }

          if (isProject && !isProjectGradientWorked) {
            bgSecEl.classList.add('is-worked-gradient-animation');
            resumeProjectGradientAnimation();
          }

          if (isLatestWorks && !isLatestWorksGradientWorked) {
            bgSecEl.classList.add('is-worked-gradient-animation');
            resumeLatestWorksGradientAnimation();
          }
        }
      },
    });
    bgFixedTriggers.push(scrollTrigger);

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }
  });
};

window.addEventListener('orbital-gradient:footer-ready', () => {
  if (bgFixedTriggers.length) {
    bgFixedAnimation();
  }
});

if (!document.querySelector('.bold-loader-new')) {
  bgFixedAnimation();
}
